import React from "react";
import NavBar from "./components/NavBar";
import Hero from "./components/Hero";
import Cards from "./components/Cards";
import Brands from "./components/Brands";



function App() {
  return (
    <div>
      <NavBar/ >
      <Hero/>
      <Cards/>
      <Brands/>

    </div>
  );
}

export default App;
